<template>
  <span>{{ _text }}</span>
</template>

<script>
import { isEmpt } from "@/utils/utils";
import { EMPT_TEXT } from "../common";

export default {
  props: {
    items: {
      type: [Function, Array],
      default: () => [],
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    _text() {
      let curItem = undefined;
      if (Array.isArray(this.items)) {
        curItem = this.items.find((item) => item.value === this.value);
      }
      if (curItem) {
        return curItem.text;
      } else {
        return isEmpt(this.value) ? EMPT_TEXT : this.value;
      }
    },
  },
};
</script>
